import React from 'react'
import { IonCard } from '@ionic/react';

//	S T Y L E

import './com-discover-element.scss'

//	T Y P E S

import { type___api___response } from '../../types/types.api-response';

//	S T A T E S   -   P R O P S

import { props___ComDiscoverElementComponent, state___ComDiscoverElementComponent, state___ComDiscoverElementComponent___default } from './com-discover-element.state';

//	S E R V I C E S 

import { service_RestApiService } from '../../services/service-api';

//	C O M P O N E N T S

import ComEventComponent from '../com-events/com-event/com-event';
import ComPoiComponent from '../com-poi/com-poi/com-poi';
import ComSpinnerInlineComponent from '../com-spinners/com-spinner-inline/com-spinner-inline';

//	M O D A L S

import MdEventsViewModal from '../../modals/md-events-view/md-events-view';
import MdPoiViewModal from '../../modals/md-poi-view/md-poi-view';

//	C L A S S

export default class ComDiscoverElementComponent extends React.Component<props___ComDiscoverElementComponent, state___ComDiscoverElementComponent> {

//#region 																							D E C L A R A T I O N S

	private readonly _API: service_RestApiService = new service_RestApiService();

//#endregion

//#region 																							C O N S T R U C T O R

	constructor(
		public props: props___ComDiscoverElementComponent,
	) {
		super(props);
		this.state = state___ComDiscoverElementComponent___default;
	}

//#endregion

//#region 																							H A N D L E R S

	private read_props___logic = () => {
		switch (this.props.element___type) {
			case 'event': this.read_props___event(); break;
			case 'poi': this.read_props___poi(); break;
		}
	}

	private read_props___poi = async () => {
		const ___selected___poi___props: type___api___response = await this._API.poi___read___single(this.props.element___id);
		this.setState({
			element___props: ___selected___poi___props.data,
			element___props___isLoading: false,
		});
	}

	private read_props___event =  async () => {
		const ___selected___event___props: type___api___response = await this._API.events___read___single(this.props.element___id);
		this.setState({
			element___props: ___selected___event___props.data,
			element___props___isLoading: false,
		});
	}

//#endregion

//#region 																							H A N D L E R S

	private handle___toggle_mode = () => {
		const ___old___show_full: boolean = this.state.show_full;
		this.setState({
			show_full: !___old___show_full,
		});
	}

//#endregion

//#region 																							L I F E C Y C L E

	componentDidMount(): void {
		this.setState({
			element___props___id: this.props.element___id,
			element___props___type: this.props.element___type,
			element___props: (this.props.element___props !== null) ? this.props.element___props : null,
			element___props___isLoading: (this.props.element___props !== null) ? false : true,
		}, () => {
			this.read_props___logic();
		});
	}

	componentDidUpdate(prevProps: props___ComDiscoverElementComponent, prevState: state___ComDiscoverElementComponent) : void {
		if (this.props !== prevProps) {
			this.setState({
				element___props___id: this.props.element___id,
				element___props___type:  this.props.element___type,
				element___props: (this.props.element___props !== null) ? this.props.element___props : null,
				element___props___isLoading: (this.props.element___props !== null) ? false : true,
			}, () => {
				this.read_props___logic();
			});
		}
	}

//#endregion

//#region 																							R E N D E R

	render() : React.ReactNode {
		return <>
			<div className={'com-discover-element---container ' + ((this.state.show_full === true) ? ' com-discover-element---container---is-modal ' : '')}>
				<div className="com-discover-element---container---button">
					{(this.state.show_full === true) ? <>
						<i className="fas fa-times is-element is-card" onClick={ this.handle___toggle_mode }></i>
					</> : <>
						<i className="fas fa-chevron-up is-element is-card" onClick={ this.handle___toggle_mode }></i>
					</>}
				</div>
				{(this.state.element___props___isLoading === true || this.state.element___props === null) ? <>
					<IonCard>
						<ComSpinnerInlineComponent/>
					</IonCard>
				</> : <>
					{(() => { switch (this.state.element___props___type) {
						case 'event': return <>
							{(() => { switch (this.state.show_full) {
								case true: return <>
									<MdEventsViewModal event_id={ this.state.element___props['event_id'] } />
								</>; break;
								default: return <>
									<section onClick={ this.handle___toggle_mode }>
										<ComEventComponent event_props={ this.state.element___props } />
									</section>
								</>; break;
							}})()}
						</>; break;
						case 'poi': return <>
							{(() => { switch (this.state.show_full) {
								case true: return <>
									<MdPoiViewModal poi_id={ this.state.element___props['poi_id'] } />
								</>; break;
								default: return <>
									<section onClick={ this.handle___toggle_mode }>
										<ComPoiComponent poi_props={ this.state.element___props } />
									</section>
								</>; break;
							}})()}
						</>; break;
						default: return <>
							<ComSpinnerInlineComponent/>
						</>; break;
					}})()}
				</>}
			</div>
		</>;
	}

//#endregion

}